'use strict';

import { Entity } from '../Entity';
import { GlobSunfireOrg } from '../Glob/GlobSunfireOrg';

export class UserSunfire extends Entity {
  protected id;
  protected sunfireOrg;
  protected sunfireOrgUserId;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    /* if (data.sunfireOrg) {
             let sunfireOrgs = new GlobSunfireOrgCollection();
 
             data.sunfireOrg.forEach(singleSunfireOrgData => {
                 let org = new GlobSunfireOrg();
                 org.hydrate(singleSunfireOrgData);
 
                 sunfireOrgs.addItem(org);
             });
 
             this.sunfireOrg = sunfireOrgs;
         } */

    if (data.sunfireOrg) {
      const sunfireOrga = new GlobSunfireOrg();
      sunfireOrga.hydrate(data.sunfireOrg);

      this.sunfireOrg = sunfireOrga;

      this.sunfireOrgUserId = data.sunfireOrgUserId;
    }
  }

  public getId() {
    return this.id;
  }

  public getSunfireOrg() {
    return this.sunfireOrg;
  }

  public getSunfireOrgUserId() {
    return this.sunfireOrgUserId;
  }
}
